export default class Terms {

	constructor(name) {

		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			items: [],
			catId: null,
			TermId: null,
			query: '',

			init(TermId) {
				var vm = this;
				vm.TermId = TermId;
				var xhttp = new XMLHttpRequest();

				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						vm.loading = false
						vm.items = JSON.parse(this.responseText)[0]['items']
					}
				}

				xhttp.open('get', '/api/term/' + TermId, true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				// setTimeout(function() {
					xhttp.send();
				// }, 500)
			},

			EditItem(item) {
				Turbolinks.visit( '/term/' + item.term_id + '/item/' + item.id )
			},

			OpenIssue(Issue){
				Turbolinks.visit( '/term/' + Issue.term_id + '/item/' + Issue.item_id + '/issue/' +  Issue.id)	
			},

			filterItems(vm = this) {

				var AllItems = vm.items;
				var SearchableKeys = ['name', 'id']
				var SearchString = vm.query.toLowerCase();

				return AllItems.filter(product => {
					let flag = false;
					for (let SearchKey of SearchableKeys) {
						if( product[SearchKey] ){
							flag = product[SearchKey].toString().toLowerCase().indexOf(SearchString) > -1
						}
						if (flag) break;
					}
					return flag;
				});
			}
		}
	}
}